// ------------------------------------------------------------------------------
// name: Breakpoints - 全局统一 Breakpoints
// author: mudas
// created: 2024/12/18
// ------------------------------------------------------------------------------

export const Breakpoints = {
  xs: 0,
  sm: 1280,
  md: 1600,
  lg: 1920,
  xl: 2560,
  xxl: 3200,
  xxxl: 3840,
};
